import { Link, isRouteErrorResponse, useRouteError } from "react-router";

export function RouteErrorFallback() {
  const error = useRouteError();
  console.error("[RouteErrorFallback]", error);

  const title = isRouteErrorResponse(error)
    ? `${error.status} ${error.statusText}`
    : "Something went wrong";
  const description = isRouteErrorResponse(error)
    ? error.data?.message || "We couldn't load this page right now."
    : "An unexpected error occurred while loading this page. Please try again.";

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-6">
      <div className="w-full max-w-lg rounded-3xl border border-gray-200 bg-white p-8 text-center shadow-sm">
        <div className="mx-auto mb-5 flex h-14 w-14 items-center justify-center rounded-full bg-orange-50">
          <span className="text-2xl text-orange-500">!</span>
        </div>
        <h1 className="text-2xl font-black tracking-tight text-gray-900">
          {title}
        </h1>
        <p className="mt-3 text-sm leading-6 text-gray-600">{description}</p>
        {import.meta.env.DEV && error instanceof Error && (
          <pre className="mt-4 max-h-40 overflow-auto rounded-xl bg-gray-950 p-3 text-left text-xs text-gray-100">
            {error.message}
          </pre>
        )}
        <div className="mt-6 flex flex-col gap-3 sm:flex-row sm:justify-center">
          <button
            onClick={() => window.location.reload()}
            className="rounded-xl bg-orange-500 px-5 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-orange-600"
          >
            Refresh page
          </button>
          <Link
            to="/hub"
            className="rounded-xl bg-gray-100 px-5 py-2.5 text-sm font-semibold text-gray-700 transition-colors hover:bg-gray-200"
          >
            Back to home
          </Link>
        </div>
      </div>
    </div>
  );
}
